module.exports = __webpack_public_path__ + "img/img_aboutus_goal_schools@2x.01c6253f.png";